// src/api/mockTestApi.js
//
// Student-facing Mock Test API calls, matching pyqApi.js's convention
// (askosAuthHeader() passed explicitly per call).
import api from './api';
import { askosAuthHeader } from '../askos/askosApi';

export const listMockTests = (slug) =>
  api.get(`/tenant/${slug}/askos/mock-tests`, { headers: askosAuthHeader() }).then(r => r.data);

export const startMockTest = (slug, testId) =>
  api.post(`/tenant/${slug}/askos/mock-tests/${testId}/start`, {}, { headers: askosAuthHeader() }).then(r => r.data);

export const getMockTestQuestions = (slug, testId) =>
  api.get(`/tenant/${slug}/askos/mock-tests/${testId}/questions`, { headers: askosAuthHeader() }).then(r => r.data);

export const submitMockAttempt = (slug, attemptId, answers) =>
  api.post(`/tenant/${slug}/askos/mock-attempts/${attemptId}/submit`, { answers }, { headers: askosAuthHeader() }).then(r => r.data);

export const getMockAttemptResult = (slug, attemptId) =>
  api.get(`/tenant/${slug}/askos/mock-attempts/${attemptId}/result`, { headers: askosAuthHeader() }).then(r => r.data);

export const updateSelfScores = (slug, attemptId, scores) =>
  api.patch(`/tenant/${slug}/askos/mock-attempts/${attemptId}/self-score`, { scores }, { headers: askosAuthHeader() }).then(r => r.data);
